import { render, staticRenderFns } from "./ThreeOptionsListOrd.vue?vue&type=template&id=57b1fe52"
import script from "./ThreeOptionsListOrd.vue?vue&type=script&lang=ts"
export * from "./ThreeOptionsListOrd.vue?vue&type=script&lang=ts"
import style0 from "./ThreeOptionsListOrd.vue?vue&type=style&index=0&id=57b1fe52&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports